import React from "react";

const iconStyle = {
  width: 16,
  height: 16,
  verticalAlign: "middle",
  marginRight: 6,
  flexShrink: 0,
};

// Panel header icons
export const EyeIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="3" stroke="#98A2B3" strokeWidth="2"/>
  </svg>
);

export const SpeechIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const BrainIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2a7 7 0 00-5.2 11.6A5 5 0 009 22h6a5 5 0 002.2-8.4A7 7 0 0012 2z" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2v20" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 3"/>
  </svg>
);

export const TargetIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="10" stroke="#98A2B3" strokeWidth="2"/>
    <circle cx="12" cy="12" r="6" stroke="#98A2B3" strokeWidth="2"/>
    <circle cx="12" cy="12" r="2" stroke="#98A2B3" strokeWidth="2"/>
  </svg>
);

export const TextIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 7V4h16v3M9 20h6M12 4v16" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ShapesIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="8" cy="16" r="5" stroke="#98A2B3" strokeWidth="2"/>
    <rect x="11" y="3" width="10" height="10" rx="2" stroke="#98A2B3" strokeWidth="2"/>
  </svg>
);

export const ClockBrainIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="10" stroke="#98A2B3" strokeWidth="2"/>
    <path d="M12 6v6l4 2" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CompassIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="10" stroke="#98A2B3" strokeWidth="2"/>
    <polygon points="16.24,7.76 14.12,14.12 7.76,16.24 9.88,9.88" fill="#98A2B3" opacity="0.5" stroke="#98A2B3" strokeWidth="1.5"/>
  </svg>
);

// Visual/Executive item icons
export const PentagonsIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <polygon points="8,3 13,6 11,12 5,12 3,6" stroke="#98A2B3" strokeWidth="1.5" fill="none"/>
    <polygon points="16,8 21,11 19,17 13,17 11,11" stroke="#98A2B3" strokeWidth="1.5" fill="none"/>
  </svg>
);

export const CubeIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2l9 5v10l-9 5-9-5V7l9-5z" stroke="#98A2B3" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M12 22V12M12 12l9-5M12 12L3 7" stroke="#98A2B3" strokeWidth="1.5"/>
  </svg>
);

export const WavyLineIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M2 12c2-3 4-3 6 0s4 3 6 0 4-3 6 0" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const NumbersIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <text x="2" y="17" fontFamily="sans-serif" fontSize="14" fontWeight="600" fill="#98A2B3">123</text>
  </svg>
);

export const HandIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M18 10V6a2 2 0 00-4 0v1M14 7V4a2 2 0 00-4 0v6M10 5V4a2 2 0 00-4 0v8" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 10a2 2 0 014 0v2a8 8 0 01-8 8h-2a8 8 0 01-6-2.7" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Maps
export const mocaPanelIcons = {
  visual: EyeIcon,
  naming: SpeechIcon,
  memory: BrainIcon,
  attention: TargetIcon,
  language: TextIcon,
  abstraction: ShapesIcon,
  delayedRecall: ClockBrainIcon,
  orientation: CompassIcon,
};

export const visualItemIcons = {
  begin_end: PentagonsIcon,
  copy_cube: CubeIcon,
  contour: WavyLineIcon,
  numbers: NumbersIcon,
  hands: HandIcon,
};
